const isNumber = value => !isNaN(value);

export default isNumber;
